<template>
    <div class="pp-lottery-winnings">
        <DsDropdown v-model="selectedOption" :options="options" id="pp-lottery-winnings-options" />
        <DsTable v-if="!isSystemBet" class="pp-lottery-winnings__table">
            <DsRow>
                <DsCell type="th" class="pp-lottery-winnings__cell">Uhodnuto čísel</DsCell>
                <DsCell type="th" class="pp-lottery-winnings__cell">Výhra</DsCell>
            </DsRow>
            <DsRow v-for="(order, index) in selectedRegularBetData" :key="index">
                <DsCell class="pp-lottery-winnings__cell">{{ order[0] }}</DsCell>
                <DsCell class="pp-lottery-winnings__cell"
                    ><span v-html="StringUtils.formatCurrency(order[1])"></span
                ></DsCell>
            </DsRow>
        </DsTable>

        <template v-else>
            <DsTable v-for="data in winningsSystemBetData" :key="data.guessedCount" class="pp-lottery-winnings__table">
                <DsRow>
                    <DsCell type="th" colspan="5" class="pp-lottery-winnings__cell">
                        <strong>
                            Tipováno {{ data.minBet }} až {{ data.maxBet }} čísel, uhodnuto {{ data.guessedCount }}
                        </strong>
                    </DsCell>
                </DsRow>
                <DsRow>
                    <DsCell type="th" colspan="5" class="pp-lottery-winnings__cell">
                        Vsazené kombinace na daný počet čísel
                    </DsCell>
                </DsRow>
                <DsRow class="pp-lottery-winnings__row">
                    <DsCell v-for="n in 5" :key="n" type="th" class="pp-lottery-winnings__cell">
                        {{ 6 - n }}
                    </DsCell>
                </DsRow>
                <DsRow>
                    <DsCell
                        v-for="(multiplier, index) in data.multipliers"
                        :key="index"
                        class="pp-lottery-winnings__cell"
                    >
                        {{ multiplier }}
                    </DsCell>
                </DsRow>
            </DsTable>
        </template>
    </div>
</template>
<script lang="ts" setup>
import { ref, computed } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";

const options = [
    ...Array.from({ length: 3 }, (_, index) => ({
        value: index,
        label: `SÁZKA NA ${5 - index} ${LotteryParser.getNumberLabel(5 - index).toUpperCase()}`,
    })),
    { value: 3, label: "KOMBINOVANÁ SÁZKA" },
];

const selectedOption = ref(0);

const winningsRegularBetData = [
    [
        [5, 1_000_000],
        [4, 5_000],
        [3, 300],
        [2, 40],
    ],
    [
        [4, 10_000],
        [3, 300],
        [2, 40],
        [1, 20],
    ],
    [
        [3, 2_000],
        [2, 100],
        [1, 20],
    ],
];

const isSystemBet = computed(() => selectedOption.value === options.length - 1);
const selectedRegularBetData = computed(() => (isSystemBet.value ? [] : winningsRegularBetData[selectedOption.value]));

interface WinningsSystemBetRow {
    guessedCount: number;
    minBet: number;
    maxBet: number;
    multipliers: Array<string>;
}

const winningsSystemBetData: WinningsSystemBetRow[] = [
    {
        guessedCount: 6,
        minBet: 6,
        maxBet: 16,
        multipliers: ["1 080 000x", "120 000x", "10 000x", "675x", "24x"],
    },
    {
        guessedCount: 5,
        minBet: 5,
        maxBet: 16,
        multipliers: ["180 000x", "40 000x", "5 000x", "450x", "20x"],
    },
    {
        guessedCount: 4,
        minBet: 4,
        maxBet: 16,
        multipliers: ["–––", "8 000x", "2 000x", "270x", "16x"],
    },
    {
        guessedCount: 3,
        minBet: 3,
        maxBet: 16,
        multipliers: ["–––", "–––", "500x", "135x", "12x"],
    },
    {
        guessedCount: 2,
        minBet: 2,
        maxBet: 16,
        multipliers: ["–––", "–––", "–––", "45x", "8x"],
    },
    {
        guessedCount: 1,
        minBet: 1,
        maxBet: 16,
        multipliers: ["–––", "–––", "–––", "–––", "4x"],
    },
];
</script>
